// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export const VERSION = "2.3.1";
export const EVALUATION_EVENT_VERSION = "1.0.0";
